import PropTypes from 'prop-types';

import Controls from './Controls';
import DeleteButton from './DeleteButton';
import { Container } from './styles';

const Card = ({ onDelete, data }) => {
  const { id, path_url, portrait } = data;

  return (
    <Container imageUrl={path_url} isPortrait={portrait}>
      <Controls data={data} />
      <DeleteButton imageId={id} onDelete={onDelete} />
    </Container>
  );
};

Card.propTypes = {
  onDelete: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    path_url: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    portrait: PropTypes.bool.isRequired,
  }).isRequired,
};

export default Card;
